// Triggered when the form is submitted, used only for analytics purpose
//
const onFormSubmitted = () =>
  function () {
    document.getElementById("leads-import-form").addEventListener("turbo:submit-start", function () {
      App.analytics.ga_track("Leads import", "Creation")
    })
  }

document.addEventListener("turbo:load", function () {
  if (!App.currentPageIs("leads_imports", "new")) {
    return
  }

  return onFormSubmitted()
})
